import React, { useState, useEffect } from "react"
import { motion } from "framer-motion"
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react"
import { collection, getDocs } from "firebase/firestore"
import { db } from "../../firebase"

const TeamCard = () => {
  const [teamMembers, setTeamMembers] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchTeam = async () => {
      try {
        setLoading(true)
        const snap = await getDocs(collection(db, "team"))
        const list = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        // Sort by createdAt or name
        list.sort((a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0))
        setTeamMembers(list)
      } catch (error) {
        console.error("Error fetching team:", error)
      } finally {
        setLoading(false)
      }
    }
    fetchTeam()
  }, [])

  if (loading) {
    return (
      <>
        {[...Array(3)].map((_, i) => (
          <div key={i} className="team-item animate-pulse bg-white/5 h-80 rounded-2xl" />
        ))}
      </>
    )
  }

  return (
    <>
      {teamMembers.map((val, idx) => (
        <motion.div
          key={val.id || idx}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: idx * 0.1 }}
          whileHover={{ y: -10 }}
          className='team-item'
        >
          <div className='team-img-box'>
            <img src={val.cover || "https://img.freepik.com/free-vector/isolated-young-handsome-man-different-poses-white-background-illustration_632498-859.jpg"} alt={val.name} />
            <div className='team-social-overlay'>
              <a href={val.facebook || "#"}><Facebook size={18} /></a>
              <a href={val.twitter || "#"}><Twitter size={18} /></a>
              <a href={val.instagram || "#"}><Instagram size={18} /></a>
              <a href={val.linkedin || "#"}><Linkedin size={18} /></a>
            </div>
          </div>
          <div className='team-details'>
            <h2>{val.name}</h2>
            <p>{val.work || val.role || "Consultant"}</p>
          </div>
        </motion.div>
      ))}
    </>
  )
}

export default TeamCard

